import { ChevronDown } from 'lucide-react';
import React, { useEffect, useState } from 'react'

type Props = {
  scrollContainerRef: any
  Trigger?: any
}

const ScrollDownbtn = ({ scrollContainerRef, Trigger = "" }: Props) => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Check if content is scrollable
  const checkScrollable = () => {
    const container = scrollContainerRef?.current;
    if (container) {
      const hasScroll = container.scrollHeight > container.clientHeight;
      const isAtBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 10;
      setShowScrollButton(hasScroll && !isAtBottom);
    }
  };

  useEffect(() => {
    checkScrollable();
    const container = scrollContainerRef?.current;
    if (!container) return;

    // ✅ Initial check
    checkScrollable();
    // ✅ Watch scroll and resize
    container.addEventListener("scroll", checkScrollable);
    window.addEventListener("resize", checkScrollable);

    // ✅ NEW: Watch inner DOM changes
    const observer = new MutationObserver(checkScrollable);
    observer.observe(container, { childList: true, subtree: true });

    return () => {
      container.removeEventListener("scroll", checkScrollable);
      window.removeEventListener("resize", checkScrollable);
      observer.disconnect();
    };
  }, [Trigger, scrollContainerRef]);

  const scrollDown = () => {
    const container = scrollContainerRef?.current;
    if (container) {
      container.scrollBy({
        top: 200,
        behavior: 'smooth'
      });
    }
  };

  return (
    showScrollButton ?
      <button
        onClick={scrollDown}
        className="fixed bottom-10 md:right-50 right-45 bg-neutral-200 shadow-lg flex items-center justify-center rounded-full p-2 hover:bg-gray-100 transition-all duration-300 animate-bounce z-50"
        aria-label="Scroll down"
      >
        <ChevronDown className="w-6 h-4 text-blue-900" />
      </button> :
      null
  )
}

export default ScrollDownbtn